import React from "react";
import MetaPost from "../header/MetaPost";
import NavLink from "../button/NavLink";
import { getPortfolioLink } from "../../api/portfolio/PortfolioData";
import ButtonDefault from "../button/button-default/ButtonDefault";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";

function ContentSlider({ data, activeClass }, ref) {
  return (
    <div className="dsn-slider-content hero-content">
      {data.map((item, key) => (
        <div
          className={`slide-content ${activeClass === key ? "dsn-active" : ""}`}
          key={key}
          ref={ref}
        >
          {item.caption && <MetaPost caption={item.caption} separate=", " />}
          {item.title && (
            <h1 className="title-heading">
              <NavLink to={getPortfolioLink(item)}>{item.title}</NavLink>
            </h1>
          )}
          {item.description && (
            <div className="dsn-description mt-30">{item.description}</div>
          )}
          <ButtonDefault
            href={item.link}
            className="mt-30"
            text={item.buttonText || "View More"}
            icon={faAngleRight}
            target={item.link.startsWith("http") ? "_blank" : ""}
          />
        </div>
      ))}
    </div>
  );
}

export default React.forwardRef(ContentSlider);
